import React from "react";
import styled, { useTheme } from "styled-components";
import { useHistory } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { useAuth0 } from "@auth0/auth0-react";
import { useTranslation } from "react-i18next";
import authSelectors from "~/store/auth/selectors";
import { AuthoritiesEnum, RoutesEnum } from "~/types/enums";
import authActionCreators from "~/store/auth/actions";
import { Avatar, Dropdown, Grid, Icon, Text } from "~/components-shared";
import useAbacExt from "~/hooks/abac";
const StyledGridCell = styled(Grid.Cell)`
  overflow: hidden;
  align-self: center;
`;
const StyledText = styled(Text)`
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
`;
const UserDropdown = _ref => {
  let {
    direction = "bottomLeft"
  } = _ref;
  const {
    colors
  } = useTheme();
  const user = useSelector(authSelectors.getUser);
  const {
    t
  } = useTranslation();
  const dispatch = useDispatch();
  const {
    userHas
  } = useAbacExt();
  const history = useHistory();
  const options = [];
  const {
    logout,
    isAuthenticated
  } = useAuth0();
  if (!user) {
    return null;
  }
  if (userHas(AuthoritiesEnum.PROFILE_READ)) {
    options.push({
      id: 1,
      name: t("UserDropdown.profile"),
      icon: "profile",
      action: () => history.push(RoutesEnum.PROFILE)
    });
  }
  options.push({
    id: 11,
    name: t("UserDropdown.logOut"),
    icon: "log-out",
    action: () => {
      if (isAuthenticated) {
        logout({
          logoutParams: {
            returnTo: window.location.origin
          }
        }).finally(() => {
          dispatch(authActionCreators.loggedOut(null));
        });
      } else {
        dispatch(authActionCreators.loggedOut());
      }
    }
  });
  return /*#__PURE__*/React.createElement(Dropdown, {
    direction: direction,
    handler: /*#__PURE__*/React.createElement(Grid, {
      cols: 2,
      gap: 3,
      template: "2.85rem auto",
      align: "center",
      fullWidth: true
    }, /*#__PURE__*/React.createElement(Avatar, {
      user: user,
      size: 10,
      s: {
        mr: 3
      }
    }), /*#__PURE__*/React.createElement(StyledGridCell, null, /*#__PURE__*/React.createElement(StyledText, {
      element: "span",
      display: "block",
      fontSize: 3.5
    }, user.firstName, " ", user.lastName), /*#__PURE__*/React.createElement(StyledText, {
      fontSize: 3.5,
      element: "span",
      display: "block",
      color: "textSecondary"
    }, user.company?.name))),
    handlerProps: {
      color: "translucent",
      fullWidth: true
    },
    fullWidth: true
  }, _ref2 => {
    let {
      isOpen,
      onItemClick
    } = _ref2;
    return /*#__PURE__*/React.createElement(Dropdown.List, {
      isOpen: isOpen
    }, options.map(option => /*#__PURE__*/React.createElement(Dropdown.ListItem, {
      onClick: e => {
        onItemClick();
        option.action(e);
      },
      key: option.id
    }, /*#__PURE__*/React.createElement(Icon, {
      src: option.icon,
      s: {
        mr: 3
      },
      color: colors.text.secondary
    }), option.name)));
  });
};
export default UserDropdown;